import { useEffect } from "react";
import {
  Control,
  FieldValues,
  Path,
  PathValue,
  UseFormSetValue,
  useWatch,
} from "react-hook-form";
import { useDebouncedValue } from "./useDebouncedValue";
import { useCnpjQuery } from "./useCnpjQuery";

interface UseAutoFillCnpjParams<T extends FieldValues> {
  control: Control<T>;
  setValue: UseFormSetValue<T>;
}

export const useAutoFillCnpj = <T extends FieldValues>({
  control,
  setValue,
}: UseAutoFillCnpjParams<T>) => {
  const cnpjValue =
    (useWatch({ control, name: "cnpj" as Path<T> }) as string) ?? "";
  const debouncedCnpj = useDebouncedValue(cnpjValue, 500);

  const { data, isLoading, isFetching } = useCnpjQuery(debouncedCnpj);

  useEffect(() => {
    if (data) {
      if (data.razao_social)
        setValue(
          "name" as Path<T>,
          data.razao_social as PathValue<T, Path<T>>,
        );
      if (data.nome_fantasia)
        setValue(
          "fantasyName" as Path<T>,
          data.nome_fantasia as PathValue<T, Path<T>>,
        );
      if (data.ddd_telefone_1)
        setValue(
          "phone" as Path<T>,
          data.ddd_telefone_1 as PathValue<T, Path<T>>,
        );
    }
  }, [data, setValue]);

  return { isLoading: isLoading || isFetching };
};
